var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useMemo, useState } from 'react';
import numbro from 'numbro';
import { WidgetType } from '@common/api';
import { useLanguage } from '@base/LanguageProvider';
import Manager from '@shared/modal/Manager';
import Modal from '@shared/modal/Modal';
import ModalHeader from '@shared/modal/ModalHeader';
import ModalFooter from '@shared/modal/ModalFooter';
import TextInput from '@shared/input/TextInput';
import SelectInput from '@shared/input/SelectInput';
import { CheckBox } from '@shared/input/CheckBox';
import { parseWidgetConfig } from '@data/widgets/widgetConfig';
import { useCreateWidget, useUpdateWidget } from '@data/widgets/widgetActions';
import { ModalBody } from '@styled/Modal';
import { FormField } from '@styled/Form';
var fontSizes = [
    { label: '13', value: 13 },
    { label: '15', value: 15 },
    { label: '18', value: 18 },
    { label: '20', value: 20 },
];
function DataEditorEditor(props) {
    return (React.createElement(Modal, { width: 400 },
        React.createElement(DataEditorEditorForm, __assign({}, props))));
}
var DataEditorEditorForm = function (props) {
    var _a, _b, _c;
    var L = useLanguage().L;
    var createWidget = useCreateWidget();
    var updateWidget = useUpdateWidget();
    var _d = __read(useState(props.widget
        ? props.widget
        : {
            title: 'New Widget',
            type: (_a = props.type) !== null && _a !== void 0 ? _a : WidgetType.DATAEDITOR,
            config: JSON.stringify(parseWidgetConfig(null, WidgetType.DATAEDITOR)),
            GridId: props.gridId,
        }), 2), widgetState = _d[0], setWidgetState = _d[1];
    var widgetConfig = useMemo(function () { var _a; return parseWidgetConfig((_a = props.widget) === null || _a === void 0 ? void 0 : _a.config, WidgetType.DATAEDITOR); }, [(_b = props.widget) === null || _b === void 0 ? void 0 : _b.config]);
    var _e = __read(useState(widgetConfig.dataEditorFontSize), 2), fontSize = _e[0], setFontSize = _e[1];
    var _f = __read(useState(__assign(__assign({}, widgetConfig.dataEditorBtnControls), { step: numbro(widgetConfig.dataEditorBtnControls.step).format() })), 2), btnControls = _f[0], setBtnControls = _f[1];
    var _g = __read(useState({}), 2), invalid = _g[0], setInvalid = _g[1];
    var validate = function (payload, payloadConfig) {
        var invalid = {};
        if (payloadConfig.dataEditorBtnControls.active && Number.isNaN(payloadConfig.dataEditorBtnControls.step)) {
            invalid.step = L('Step must be a number.');
        }
        return invalid;
    };
    var done = function () { return __awaiter(void 0, void 0, void 0, function () {
        var widgetCopy, widgetCopyConfig, _invalid, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    widgetCopy = __assign({}, widgetState);
                    widgetCopyConfig = parseWidgetConfig(widgetCopy.config, WidgetType.DATAEDITOR);
                    widgetCopyConfig.dataEditorFontSize = fontSize;
                    widgetCopyConfig.dataEditorBtnControls = {
                        active: btnControls.active,
                        step: numbro.unformat(btnControls.step),
                    };
                    _invalid = validate(widgetCopy, widgetCopyConfig);
                    if (!(Object.keys(_invalid).length > 0)) return [3 /*break*/, 1];
                    setInvalid(_invalid);
                    return [3 /*break*/, 6];
                case 1:
                    widgetCopy.config = JSON.stringify(widgetCopyConfig);
                    if (!('id' in widgetCopy)) return [3 /*break*/, 3];
                    return [4 /*yield*/, updateWidget.mutateAsync(widgetCopy)];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, createWidget.mutateAsync(widgetCopy)];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5:
                    _a;
                    Manager.closeModal();
                    _b.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var toggleControlsChange = function () {
        var newBtnControls = __assign({}, btnControls);
        newBtnControls.active = !btnControls.active;
        setBtnControls(newBtnControls);
    };
    var btnControlsStepChange = function (e) {
        var newBtnControls = __assign({}, btnControls);
        newBtnControls.step = e.target.value;
        setBtnControls(newBtnControls);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { title: "".concat(L('Editing data editor'), " ").concat((_c = props.widget) === null || _c === void 0 ? void 0 : _c.title) }),
        React.createElement(ModalBody, null,
            React.createElement("form", null,
                React.createElement(FormField, null,
                    React.createElement(CheckBox, { action: toggleControlsChange, checked: btnControls.active, label: L('Button controls') })),
                React.createElement(TextInput, { label: L('Step'), value: btnControls.step, name: "step", onChange: btnControlsStepChange, invalid: invalid.step !== undefined, bottomMargin: true }),
                React.createElement(SelectInput, { name: "row", value: fontSize, label: L('Font size'), onChange: function (e) { return setFontSize(e.target.value); }, options: fontSizes, bottomMargin: true }))),
        React.createElement(ModalFooter, { done: done })));
};
export default DataEditorEditor;
